export function gtag_report_conversion(url) {
    const callback = function () {
      if (typeof url !== 'undefined') {
        // window.location = url;
      }
    };
    if (typeof window.gtag !== 'undefined') {
    console.log(url)

      window.gtag('event', 'conversion', {
        send_to: 'AW-826441334/RkwiCI3uvsMaEPb8iYoD',
        value: 1.0,
        currency: 'USD',
        event_callback: callback
      });
    }
    return false;
  }
  